import session from '@opendoor/shared-fe/build/store/session';
import agentResaleOfferPortal from './agentResaleOfferPortal';
import brokerageOfferFlow from './brokerageOfferFlow';
import homeProfile from './homeProfile';
import resaleClosingDashboard from './resaleClosingDashboard';

export type ReduxState = { [K in keyof typeof reducers]: ReturnType<typeof reducers[K]> };

const reducers = {
  agentResaleOfferPortal: agentResaleOfferPortal.reducer,
  brokerageOfferFlow: brokerageOfferFlow.reducer,
  homeProfile: homeProfile.reducer,
  resaleClosingDashboard: resaleClosingDashboard.reducer,
  session: session.reducer,
};

export default reducers;
